import "../scss/plugins/_swiper.scss";

import Swiper from "swiper";
import { A11y, Autoplay, FreeMode, Mousewheel, Navigation, Pagination, Thumbs } from "swiper/modules";
import { deepMerge, jsonToObject } from "./modules/helpers";

function swiperControlDataSelector(controlName = "", id = "") {
	const idValue = id ? '="' + id + '"' : "";
	return `[data-swiper-${controlName}${idValue}]`;
}

function swiperDefaultOption(id) {
	const options = {
		modules: [A11y, Navigation, Pagination, Thumbs, FreeMode, Autoplay, Mousewheel],
		pagination: {
			el: swiperControlDataSelector("pagination", id),
			type: "fraction",
		},
		navigation: {
			prevEl: swiperControlDataSelector("button-prev", id),
			nextEl: swiperControlDataSelector("button-next", id),
		},
		on: {
			autoplayTimeLeft(s, time, progress) {
				const thumbsSwiper = s.thumbs?.swiper;
				if (!thumbsSwiper) return;
				const activeThumb = thumbsSwiper.el.querySelector(".swiper-slide-thumb-active");
				if (activeThumb) {
					activeThumb.style.setProperty("--progress", 1 - progress);
				}
			},
			slideChange(s) {
				const thumbsSwiper = s.thumbs?.swiper;
				if (!thumbsSwiper) return;
				thumbsSwiper.slides.forEach((slide) => {
					slide.style.removeProperty("--progress");
				});
				// Opt-in: keep the active thumb in the 2nd visible position (one look-back above it).
				// Vertical thumbs: slideTo(N) aligns slide N to the top, so the previous thumb sits
				// at the top and the active thumb lands in slot 2. realIndex is loop-agnostic, so this
				// works whether or not the main swiper loops. Math.max keeps the first slide on top.
				if (s.el.dataset.thumbsAnchor === "second") {
					thumbsSwiper.slideTo(Math.max(0, s.realIndex - 1));
				}
			},
		},
	};
	return options;
}

const swiperInstances = {};

// Init thumbs swipers first (they have data-swiper-role="thumbs")
document.querySelectorAll('[data-swiper][data-swiper-role="thumbs"]').forEach((slider) => {
	const slideId = slider.id;
	if (!slideId) {
		console.warn("Warning: add ID attribute", slider);
	}

	const options = deepMerge(swiperDefaultOption(slideId), jsonToObject(slider.dataset.swiper));
	swiperInstances[slideId] = new Swiper(slider, options);
});

// Init remaining swipers
document.querySelectorAll("[data-swiper]:not([data-swiper-role])").forEach((slider) => {
	const slideId = slider.id;
	if (!slideId) {
		console.warn("Warning: add ID attribute", slider);
	}
	const options = deepMerge(swiperDefaultOption(slideId), jsonToObject(slider.dataset.swiper));

	// Link thumbs swiper if specified
	const thumbsId = slider.dataset.swiperThumbs;
	if (thumbsId && swiperInstances[thumbsId]) {
		options.thumbs = { swiper: swiperInstances[thumbsId] };
	}

	swiperInstances[slideId] = new Swiper(slider, options);
});
